import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import "../node_modules/bootstrap-icons/font/bootstrap-icons.css";
import { BrowserRouter } from "react-router-dom";
import { OrderUserProvider } from "./components/OrderUserContext";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
     <OrderUserProvider>  
      <App />
    </OrderUserProvider>
  </BrowserRouter>
);
reportWebVitals();
